const ABONOS = (state, abonos) => {
    state.abonos = abonos;
};

const TIPOABONO = (state, tipoabono) => {
    state.tipoabono = tipoabono;
};

const ABONOSERIE = (state, abonoserie) => {
    state.abonoserie = abonoserie;
};

export default {
    ABONOS,
    TIPOABONO,
    ABONOSERIE,
};